import PropTypes from 'prop-types'

import Hero from '../Hero'

const ChaosMonkeyHero = ({ contrast, background, ...rest }) => (
  <Hero
    contrast={contrast}
    css={{
      backgroundRepeat: 'no-repeat',
      backgroundSize: 'cover',
      backgroundPosition: 'center center',
      position: 'static',
    }}
    style={{ backgroundImage: `url(${background})` }}
    {...rest}
  />
)

ChaosMonkeyHero.propTypes = {
  contrast: PropTypes.bool,
  background: PropTypes.string.isRequired,
}

export default ChaosMonkeyHero
